const STARTED = 'STARTED';
const CANCELED = 'CANCELED';
const FINISHED = 'FINISHED';

export { STARTED, CANCELED, FINISHED };
